import React from 'react';
import { object } from 'prop-types';
import Reviews from '@fiverr-private/reviews/src/reviews';
import { getContext } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../shared/SafePureComponent';
import { validateReviews } from '../../utils/mainComponentsValidator';
import { PAGE_NAME } from '../../utils/events';
import { DEFAULT_REVIEWS_SORT } from '../../server/utils/reviews/fetchReviews/constants';

import './style.scss';

const GIG_PAGE = 'gig_page';

const GigReviews = ({ reviews = {} }, { general }) => {
    if (!validateReviews({ reviews })) {
        return null;
    }

    const { pageCtxId, isMobile, userId } = getContext();

    const { isPro } = general;

    const enrichData = {
        pathFinderConfig: {
            path: 'fetch_reviews',
            params: {
                perseus_name: GIG_PAGE,
                gig_id: reviews.gig_id
            }
        },
        pageCtxId,
        pageName: PAGE_NAME,
        type: DEFAULT_REVIEWS_SORT,
        displayRelevant: true,
        biEventGroup: GIG_PAGE,
        displayBreakdown: !isMobile,
        displayHelpful: true,
        currentUserId: userId
    };

    return (
        <Reviews initialState={({ ...reviews, ...enrichData })} isPro={isPro} className="gig-reviews"/>
    );
};

GigReviews.propTypes = {
    reviews: object
};

GigReviews.contextTypes = {
    general: object
};

export { GigReviews };
export default SafePureComponent(GigReviews);
